<template>
  <ContentSection :spacing="isSidebar ? 'none': 'md'">
    <!-- TITLE & TEXT -->
    <HeadingAndText :heading="data.heading" :text="data.text" />

    <!-- PUBLICATIONS -->
    <AnimatedContainer>
      <ul
        class="
          space-y-5
          sm:space-y-7
        "
      >
        <li
          v-for="entry in data.entries"
          :key="entry.id"
        >
          <CardPublication class="slide-left" :data="entry" />
        </li>
      </ul>
    </AnimatedContainer>

    <!-- LINK -->
    <AppButton
      v-if="data.link"
      :to="data.link"
      variant="primary"
      class="mt-6"
    >
      {{ $t('more') }}
    </AppButton>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsTeaserPublicationsFragment } from '#gql'

defineProps<{ data: Enforce<MainComponentsTeaserPublicationsFragment> }>()

const isSidebar = inject<boolean>('isSidebar', false)
</script>
